import { Box, Flex, Text, VStack } from '@minetrace/ui'
import { useNavigate } from 'react-router-dom'
import { LuArrowLeft, LuShieldCheck } from 'react-icons/lu'

function Section({ number, title, children }: { number: string; title: string; children: React.ReactNode }) {
  return (
    <Box>
      <Text fontSize="md" fontWeight="700" color="#012d1d" mb={2}>
        {number}. {title}
      </Text>
      <Text fontSize="sm" color="#414844" lineHeight="tall">
        {children}
      </Text>
    </Box>
  )
}

export default function PoliticaPrivacidadPage() {
  const navigate = useNavigate()

  return (
    <Box minH="100vh" bg="#f7faf8">
      {/* Header */}
      <Box bg="#012d1d" px={8} py={6}>
        <Box maxW="800px" mx="auto">
          <Flex alignItems="center" gap={4}>
            <Box
              as="button"
              type="button"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p={2}
              borderRadius="md"
              color="#a5d0b9"
              cursor="pointer"
              _hover={{ bg: 'rgba(255,255,255,0.1)', color: 'white' }}
              onClick={() => navigate(-1)}
            >
              <LuArrowLeft size={20} />
            </Box>
            <Box>
              <Text fontSize="xl" fontWeight="800" color="white" fontFamily="heading">KUNTUR</Text>
              <Text fontSize="sm" color="#a5d0b9">Compliance & Debida Diligencia</Text>
            </Box>
          </Flex>
        </Box>
      </Box>

      {/* Content */}
      <Box maxW="800px" mx="auto" px={6} py={10}>
        <VStack gap={8} alignItems="stretch">
          {/* Title */}
          <Flex gap={3} alignItems="center">
            <Box p={2.5} borderRadius="lg" bg="#d1e6ca">
              <LuShieldCheck size={24} color="#b4532a" />
            </Box>
            <Box>
              <Text fontSize="2xl" fontWeight="800" color="#012d1d" fontFamily="heading">
                Política de Privacidad
              </Text>
              <Text fontSize="sm" color="#857b71">
                Tratamiento de Datos Personales - Ley N° 29733
              </Text>
            </Box>
          </Flex>

          {/* Card */}
          <Box bg="white" borderRadius="xl" shadow="0 8px 32px rgba(0,0,0,0.06)" overflow="hidden">
            <Box px={6} py={6}>
              <VStack gap={6} alignItems="stretch">
                <Section number="1" title="Responsable del Tratamiento">
                  KUNTUR, plataforma de compliance y debida diligencia para el sector minero, es responsable del
                  tratamiento de los datos personales recopilados a través de esta plataforma. Nos comprometemos
                  a proteger la privacidad de nuestros usuarios y proveedores conforme a la Ley N° 29733, Ley de
                  Protección de Datos Personales, y su reglamento aprobado por el Decreto Supremo N° 003-2013-JUS.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="2" title="Finalidad del Tratamiento">
                  Los datos personales serán tratados con las siguientes finalidades: (a) Registro y evaluación de
                  proveedores mineros; (b) Verificación de requisitos legales y cumplimiento normativo; (c) Proceso
                  de debida diligencia y calificación de proveedores; (d) Gestión de la cadena de suministro de
                  minerales; (e) Generación de reportes de trazabilidad y cumplimiento; (f) Comunicaciones
                  relacionadas con el servicio.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="3" title="Datos Capturados">
                  Se recopilan los siguientes datos: datos de identificación empresarial (RUC, razón social, nombre
                  comercial); datos del representante legal y contactos autorizados (nombres, documento de identidad,
                  cargo, teléfono, correo electrónico); información de concesiones mineras y derechos mineros;
                  documentación de formalización (inscripción REINFO, IGAFOM, Declaración de Producción Semestral);
                  datos de ubicación y georreferenciación de operaciones; información de vehículos y transportistas
                  vinculados; e historial de transacciones y movimientos de mineral.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="4" title="Seguridad Técnica">
                  Implementamos medidas de seguridad técnicas, organizativas y legales para proteger los datos
                  personales contra el acceso no autorizado, pérdida, alteración o destrucción. Estas medidas
                  incluyen: cifrado de datos en tránsito y en reposo; controles de acceso basados en roles;
                  registros de auditoría de todas las operaciones; respaldos periódicos; y monitoreo continuo
                  de la infraestructura.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="5" title="Tiempo de Conservación">
                  Los datos personales serán conservados durante la vigencia de la relación comercial con el
                  proveedor y por un período adicional de cinco (5) años contados desde la finalización de
                  dicha relación, conforme a las obligaciones legales aplicables al sector minero y las normas
                  de conservación de documentos establecidas por la legislación peruana.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="6" title="Transferencia de Datos">
                  Los datos personales podrán ser transferidos o comunicados a: entidades reguladoras del sector
                  minero (MINEM, DREM/GREM); organismos de fiscalización ambiental y de seguridad (OEFA,
                  OSINERGMIN); la empresa contratante para fines de debida diligencia; y autoridades competentes
                  cuando sea requerido por ley. Toda transferencia se realizará garantizando un nivel adecuado
                  de protección conforme a la normativa vigente.
                </Section>

                <Box h="1px" bg="#e0e3e1" />

                <Section number="7" title="Derechos ARCO">
                  Conforme a la Ley N° 29733, usted tiene derecho a: (a) Acceso - conocer qué datos personales
                  suyos están siendo tratados; (b) Rectificación - solicitar la corrección de datos inexactos
                  o incompletos; (c) Cancelación - solicitar la eliminación de sus datos cuando ya no sean
                  necesarios; (d) Oposición - oponerse al tratamiento de sus datos por motivos legítimos. Para
                  ejercer estos derechos, puede enviar una solicitud a través de los canales de atención
                  disponibles en la plataforma, adjuntando una copia de su documento de identidad.
                </Section>
              </VStack>
            </Box>

            {/* Footer */}
            <Box px={6} py={4} bg="#f1f4f2" borderTop="1px solid #e0e3e1">
              <Text fontSize="xs" color="#857b71" textAlign="center">
                KUNTUR - Compliance & Debida Diligencia. Última actualización: Abril 2026.
              </Text>
            </Box>
          </Box>
        </VStack>
      </Box>
    </Box>
  )
}
